import React, {useState} from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import Card from './components/AgendaContent/Card';
import config from './Config';

if (document.body.contains(document.querySelector('.js_react_filter'))) {
	document.querySelectorAll('.js_react_filter').forEach((filter, index) => {
		const root = createRoot(filter);
		root.render(
				<App key={index} config={config.vvgn} rootElement={filter} />
		);
	});
}

if (document.body.contains(document.querySelector('.js_react_tiles'))) {

	const root = createRoot(document.querySelector('.js_react_tiles').parentElement	);
	const cardComponents = [];

	document.querySelectorAll('.js_react_tiles').forEach((tiles) => {
		let events = Object.values(JSON.parse(decodeURIComponent(tiles.dataset.events)));

		events.forEach((event, index) => {
			const key = `${Object.keys(event)[0]}_${index}`;
			cardComponents.push(
					<Card
						key={key}
						element={event[Object.keys(event)[0]]}
						config={config.vvgn}
						setTagsParam={() => {
							return;
						}}
					/>
			);
		});
	});

	// Render all accumulated Card components inside the root
	root.render(<>{cardComponents}</>);
}
